import { useState } from "react";
import axios from "axios";
import { AUTH } from "../config/apiConfig";

/*
  Login do staff.

  Duas coisas saíram daqui na reformulação:

  - **`tokenFCM`.** O antigo enviava um token de push junto com a senha, e o
    back-office nunca o guardou — a tabela do staff não tem o campo. O efeito
    visível era o painel pedir permissão de notificação no navegador para
    nada.

  - **`saveUserInWindow()`.** Guardava o usuário decodificado num global do
    `window`. Quem manda sobre papel e permissão é o servidor, que relê o
    staff do banco a cada request; um espelho no front só criava uma segunda
    verdade, desatualizada depois de uma troca de papel.
*/
const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = async (email, password) => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await axios.post(AUTH.LOGIN, { email, password });

      if (!data?.token) throw new Error("Resposta de login sem token.");

      localStorage.setItem("token", data.token);
      setLoading(false);

      return data.token;
    } catch (requestError) {
      setLoading(false);
      setError(requestError);
      throw requestError;
    }
  };

  return { loading, error, login };
};

export default useLogin;
